<!-- <h2>PDF Viewer</h2> -->

  <!-- <div *ngIf="isLoaded" style="text-align: center;">
    <button (click)="prevPage()" [disabled]="page === 1">Prev</button>
    <span>{{ page }} / {{ totalPages }}</span>
    <button (click)="nextPage()" [disabled]="page === totalPages">Next</button>
  </div> -->


<div class="pdf-container">
   <!-- <pdf-viewer [src]="src"
   [original-size]="false"
   [render-text] = "true"
  ></pdf-viewer> -->
  <ng2-pdfjs-viewer #viewpdf [pdfSrc]="src" style="height: 500px;"></ng2-pdfjs-viewer>


</div>
<div class="ui-g-12 ui-md-12">
  <button type="button" pButton  label="Terminar Revisión" (click)="docLeido()"
      class="ui-button-info" style="width: 100%;"></button>
</div>

<!-- [original-size]="false"
[render-text] = "true"
(pagechanging)="pagechanging($event)"

(page-rendered)='pageRendered($event)'
(pageChange)='pageChange($event)' -->


<!-- [show-all]="false"
[page]="page"
(after-load-complete)="afterLoadComplete($event)" -->